<template>
  <div v-if="type">
    <h1>Create group</h1>
    <EntityWorking v-if="entity" :entity="entity" />
    <v-form ref="formGroup" v-model="valid" lazy-validation>
      <v-text-field
        label="Group name"
        v-model="group.name"
        :rules="lengthRules.concat(valueRules)"
        :counter="255"
        outline
      />
      <v-btn @click="saveGroup()">
        <v-icon>save</v-icon>Save
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import EntityWorking from "@/components/link/EntityWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "GroupCreate",
  metaInfo() {
    return {
      title: "Group create",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityWorking },
  data() {
    return {
      type: null,
      entity: null,
      group: { name: "" },
      lengthRules: [
        v =>
          !v ||
          (v && v.length <= 255) ||
          "This must be less than 255 characters"
      ],
      valueRules: [v => !!v || "Value is required"],
      valid: false
    };
  },
  methods: {
    fetchType() {
      nbmlaw
        .get(`/cors/admin/directory/types/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.type = response.data;
        })
        .catch(() => {});
    },
    fetchEntity() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.query.entityid}`)
        .then(response => {
          // console.log(response.data);
          this.entity = response.data;
        });
    },
    saveGroup() {
      if (this.$refs.formGroup.validate()) {
        nbmlaw
          .post(
            `/cors/admin/directory/types/${this.$route.params.id}/groups`,
            this.group,
            {
              params: { entityid: this.$route.query.entityid }
            }
          )
          .then(() => {
            // console.log(response.data);
            this.navigate();
          })
          .catch(() => {});
      }
    },
    navigate() {
      if (this.$route.query.entityid) {
        this.$router.push({
          name: "entity",
          params: { id: this.$route.query.entityid }
        });
      } else {
        this.$router.push({
          name: "groupAssign",
          params: { id: this.$route.params.id }
        });
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchType();
      }
    },
    "$route.query.entityid": {
      immediate: true,
      handler() {
        if (this.$route.query.entityid) {
          this.fetchEntity();
        } else {
          this.entity = null;
        }
      }
    }
  }
};
</script>
